import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

const EVENTS = [
  // {
  //   id: 1,
  //   title: 'Event Title',
  //   summary: 'Short summary text.',
  //   details: '**Section**\n\nDetailed content here.',
  //   date: 'DD.MM.YYYY',
  // },
];

export default function EventModal({ open, onClose }) {
  const [selected, setSelected] = useState(null);

  if (!open) return null;

  // Open links in new tab
  const markdownComponents = {
    a: (props: any) => (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    ),
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.25)',
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 360,
          maxHeight: 520,
          background: '#E3FAFB',
          borderRadius: 18,
          boxShadow: '0 6px 18px 0 rgba(0,0,0,0.14)',
          padding: 18,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 14,
            right: 18,
            background: 'transparent',
            border: 'none',
            fontSize: 24,
            cursor: 'pointer',
            color: '#349CA5',
          }}
        >
          ×
        </button>

        {/* Title */}
        <div
          style={{
            fontWeight: 700,
            fontSize: 23,
            color: '#21B6B4',
            marginBottom: 22,
            textAlign: 'center',
            letterSpacing: 0.5,
          }}
        >
          • Events •
        </div>

        {selected === null ? (
          // List view
          <div>
            {EVENTS.map((event) => (
              <div
                key={event.id}
                onClick={() => setSelected(event.id)}
                style={{
                  background: '#fff',
                  padding: '12px 16px',
                  borderRadius: 14,
                  marginBottom: 13,
                  cursor: 'pointer',
                  boxShadow: '0 1px 5px 0 rgba(36,210,219,0.08)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 6,
                  }}
                >
                  <div
                    style={{ fontWeight: 600, fontSize: 16, color: '#349CA5' }}
                  >
                    {event.title}
                  </div>
                  <div
                    style={{ fontSize: 12, color: '#B6B6B6', marginLeft: 12 }}
                  >
                    {event.date}
                  </div>
                </div>
                <div
                  style={{ fontSize: 14, color: '#505050', opacity: 0.78 }}
                >
                  {event.summary}
                </div>
              </div>
            ))}
          </div>
        ) : (
          // Detail view
          <div
            style={{
              background: '#fff',
              padding: '18px 16px 30px 16px',
              borderRadius: 14,
              marginBottom: 10,
              boxShadow: '0 1px 8px 0 rgba(36,210,219,0.10)',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              <div
                style={{ fontWeight: 700, fontSize: 18, color: '#26A5A8' }}
              >
                {EVENTS.find((e) => e.id === selected)?.title}
              </div>
              <div
                style={{ fontSize: 12, color: '#B6B6B6', marginLeft: 12 }}
              >
                {EVENTS.find((e) => e.id === selected)?.date}
              </div>
            </div>
            <div
              style={{ fontSize: 15, color: '#303030', marginBottom: 26 }}
            >
              <ReactMarkdown components={markdownComponents}>
                {EVENTS.find((e) => e.id === selected)?.details || ''}
              </ReactMarkdown>
            </div>
            <button
              onClick={() => setSelected(null)}
              style={{
                border: 'none',
                background: '#ABE5EA',
                color: '#349CA5',
                borderRadius: 8,
                padding: '7px 18px',
                fontWeight: 500,
                fontSize: 15,
                cursor: 'pointer',
                marginTop: 4,
              }}
            >
              Back to List
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
